import { Flex } from '@stars-ecom/shared-atoms-ui'
import React  from 'react'

const ReviewLink = (props) => {
  const { showReviewWidget, reviewIdWidget } = props
  if (!!showReviewWidget && !!reviewIdWidget) {
    return (
      <Flex
        direction="row"
        justifyContent="center"
        w={{ md: "200px" }}
        mt={{ base: 0, md: '14px' }}
      >
          <div id={reviewIdWidget} />
      </Flex>
    );
  } else {
    return null
  }
}

export default ReviewLink
